import classNames from "classnames";
import * as React from "react";
function classNameComponent(name, className, defaultElement) {
    const component = React.forwardRef(({ $as, as, className: classNameFromProp, children, ...props }, ref) => React.createElement($as ?? as ?? defaultElement, {
        ...props,
        className: classNames(classNameFromProp, className),
        ref: ref,
    }, children));
    component.displayName = name;
    component.className = className;
    component.selector = `${component.className
        .split(" ")
        .map((x) => `.${x}`)
        .join("")}`;
    return component;
}
function recipeComponent(name, componentRecipe, defaultElement) {
    const component = React.forwardRef(({ $as, as, className, children, ...props }, ref) => {
        const variants = new Set(componentRecipe.variants());
        const variantKeys = [];
        const htmlKeys = [];
        Object.keys(props).forEach((x) => {
            if (variants.has(x)) {
                variantKeys.push(x);
            }
            else {
                htmlKeys.push(x);
            }
        });
        const variantSelection = Object.fromEntries(variantKeys.map((key) => [key, props[key]]));
        const htmlProps = Object.fromEntries(htmlKeys.map((key) => [key, props[key]]));
        const componentClass = componentRecipe(variantSelection);
        return React.createElement($as ?? as ?? defaultElement, {
            ...htmlProps,
            className: classNames(className, componentClass),
            ref: ref,
        }, children);
    });
    component.displayName = name;
    component.className = componentRecipe.classNames.base;
    component.selector = `.${component.className}`;
    return component;
}
export function component(name, classNameOrRecipe, defaultElement) {
    if (typeof classNameOrRecipe === "string") {
        return classNameComponent(name, classNameOrRecipe, defaultElement);
    }
    return recipeComponent(name, classNameOrRecipe, defaultElement);
}
